'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import PhasesController from "./controller/phases";
import PhaseSelectController from "./controller/phases";
import PhaseModalCreateController from "./controller/phaseModalCreate";
import PhaseModalSelectController from "./controller/phaseModalSelect";
import PhaseTableDirective from "./directive/phaseTable";
import PhaseService from "./service/phase";

export default angular.module('investmentProject.phase', [])
    .controller('PhasesController', PhasesController)
    .controller('PhaseModalCreateController', PhaseModalCreateController)
    .controller('PhaseModalSelectController', PhaseModalSelectController)
    .controller('PhaseSelectController', PhaseSelectController)
    .directive('phaseTable', PhaseTableDirective)
    .factory('PhaseService', PhaseService)
    .name;
